var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon2, _polygon3, _path9, _path10, _path11, _polygon4, _polygon5, _path12, _path13, _polygon6, _polygon7, _rect, _path14, _path15, _path16, _polygon8, _polygon9, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect2, _rect3, _path27, _path28, _path29, _rect4, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect5, _rect6, _rect7, _g, _rect8, _path39, _path40, _path41, _g2, _rect9, _rect10, _rect11, _path42, _path43, _path44, _path45, _path46, _polygon10, _polygon11, _polygon12, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _rect12, _rect13, _rect14, _rect15, _rect16, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _polygon13, _polygon14, _path78, _path79, _polygon15, _polygon16, _path80, _path81, _path82, _path83, _g3, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _rect17, _rect18, _rect19, _rect20, _rect21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 372.68 265.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#78c2ff;}.cls-2{fill:#0e2d3d;}.cls-3{fill:#285173;}.cls-4{fill:#1d3b54;}.cls-5{fill:#eea886;}.cls-6{fill:#eddad3;}.cls-7{fill:#d6c5be;}.cls-8{fill:#fae6de;}.cls-9{fill:#eb4747;}.cls-10{fill:#e8734d;}.cls-11{fill:#eea987;}.cls-12{fill:#a77860;}.cls-13{fill:#869135;}.cls-14{fill:#48753a;}.cls-15{fill:#bbd070;}.cls-16{fill:#97a43c;}.cls-17{fill:#4da8f2;}.cls-18{fill:#c2bebc;}.cls-19{fill:#73c0ff;}.cls-20{fill:#dae8f5;}.cls-21{fill:#1a598c;}.cls-22{fill:#2273b5;}.cls-23{fill:#6eb2eb;}.cls-24{fill:#e3f2ff;}.cls-25{opacity:0.58;}.cls-26{fill:#e0f1ff;}.cls-27{opacity:0.82;}.cls-28{fill:#87c9ff;}.cls-29{fill:#d6d6d6;}.cls-30{fill:#e8e8e8;}.cls-31{fill:#c2c2c2;}.cls-32{fill:#d4d8e8;}.cls-33{fill:#a9adba;}.cls-34{fill:#1c4154;}.cls-35{fill:#2a617d;}.cls-36{fill:#326ea0;}.cls-37{fill:#215b8a;}.cls-38{fill:#16202e;}.cls-39{fill:#344052;}.cls-40{opacity:0.86;}.cls-41{fill:#a1d4ff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.69 119.4 29.75 119.4 29.75 133.13 29.75 136.02 32.65 133.13 48.69 133.13 48.69 119.4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.11,230.23s4.63,2.27,3.48,8.43-1.65,7-.37,9.4,2.8,12.69,1.64,14.64-14.27-8.56-16.09-17.38,1.15-12.73,2.2-14.19S73,228.15,77.11,230.23Z",
    transform: "translate(-56.63 -105.42)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.39,252.48a6.44,6.44,0,0,1,3.68,2.43c.92,1.36,1,4.37,1.13,4.94s1.89,7,1.89,7l-4.91,3.29Z",
    transform: "translate(-56.63 -105.42)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.54,362.27s3.2,4.31,2.76,5-3.81.78-5.86,0-2.1-5.84-3-8c-.39-.91.44-3.59,1.61-3.79a5,5,0,0,1,2.44.38S93.25,358.9,96.54,362.27Z",
    transform: "translate(-56.63 -105.42)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.49,355.81a20.55,20.55,0,0,1,.92,3.59c.2,1.46,2.28,4.55,2.18,4.93s-2.73.75-3.81-.26-1.76-3.94-2-5.69a14,14,0,0,0-.5-2.44S93.46,354.73,94.49,355.81Z",
    transform: "translate(-56.63 -105.42)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.64,362.34s3.09,4.24,2.65,4.93-3.81.78-5.87,0-2.1-5.84-3-8c-.38-.91.45-3.59,1.62-3.79a5.3,5.3,0,0,1,2.54.42S65.35,359,68.64,362.34Z",
    transform: "translate(-56.63 -105.42)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.55,355.88a28.39,28.39,0,0,0,.63,3.42c.39,1.42,2.49,4.65,2.4,5s-2.74.75-3.81-.26-1.91-3.92-2-5.69a9.25,9.25,0,0,1,.25-2.92A2.4,2.4,0,0,1,66.55,355.88Z",
    transform: "translate(-56.63 -105.42)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82,285.63s2.75,12.79,3.38,16,2.4,18.83,2.59,21.48,2.87,12.66,2.74,13.6,4,20,4,20a2.48,2.48,0,0,1-2.88.1c-.76-.53-9-17.82-9-22.56,0-6.55-4.84-15.1-5.46-16.57-5.81-13.61-4.67-17.77-5.42-18.65s-.83.54-1.27,2.5-1.39,18.89-2,21-.12,9.41-.44,13.08-1.7,20.23-1.7,20.23a1.51,1.51,0,0,1-2.58.05c-.33-.36-2.61-18.47-2.67-22.82s-.13-10.37-.25-12.26c-1.17-18.06-4-20.64.48-33.43C70,263.49,82,285.63,82,285.63Z",
    transform: "translate(-56.63 -105.42)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.52,282.05s-7.84,11-4.47,34.3c0,0,18.59,2.53,28.55-2.93,0,0-4.12-24.05-5.61-27.79S63.52,282.05,63.52,282.05Z",
    transform: "translate(-56.63 -105.42)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "33.7 253.45 33.7 257.97 34.28 257.97 34.28 254.48 33.7 253.45"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "5.68 253.45 5.68 257.97 6.27 257.97 6.27 254.48 5.68 253.45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74,250.88a30.11,30.11,0,0,0,3.89,1.57c1,.2,4.89,5.25,5.58,7.1s0,4.61-1.41,7.85-.08,4.34-.72,7.58a75.82,75.82,0,0,0-1.08,11.93c.12,1.81-16.22,2.15-20-1.14,0,0,3.75-5.61,4.23-6.42s.08-5.17-.36-6.29-3.38-10.67-3.38-10.67-2.4-7.33-.23-9c1.88-1.46,7-2,7.94-2.31A15.8,15.8,0,0,1,74,250.88Z",
    transform: "translate(-56.63 -105.42)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M75,257.32l1.76-2-1.52-5.41A35.29,35.29,0,0,0,75,257.32Z",
    transform: "translate(-56.63 -105.42)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.41,247.55s-.08.73-.17,1.73c0,.44-.09.94-.13,1.45a34,34,0,0,0-.16,3.84s-3,3-6.41-3.51a8.92,8.92,0,0,0,.36-6.34C67.82,241.06,75.41,247.55,75.41,247.55Z",
    transform: "translate(-56.63 -105.42)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.33 149.15 18.33 151.9 14.87 149.32 18.33 149.15"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "18.33 151.9 16.89 150.12 12.06 145.31 10.5 146.81 18.33 151.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68,251.19s4,6.15,4.25,8.86S70.76,283,69.4,289.51s-11.19-.73-11.19-.73,6.6-10.7,4.07-19.26-3.46-12-3.46-12,.87-4.77,4-5.44C65.5,251.5,68,251.19,68,251.19Z",
    transform: "translate(-56.63 -105.42)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.76,260.37s.73,2.58-2.11,8.3c0,0,0,7.32.12,9.6s1.7,10.51,1.7,10.51l-3.89,2.07a.79.79,0,0,1-1.19-.78c.79-6.58,3.39-31.53-2.22-38.24l2.25.67A18.17,18.17,0,0,1,83.76,260.37Z",
    transform: "translate(-56.63 -105.42)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "20.08 149.84 22.29 150.45 18.56 144.43 20.08 149.84"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "16.89 150.12 14.87 152.77 10.73 145.86 12.06 145.31 16.89 150.12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 79.05,
    y: 265.09,
    width: 0.73,
    height: 8.65,
    transform: "translate(-206.57 1.86) rotate(-38.32)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.11,272.26A1.59,1.59,0,0,0,77,272c.58-.44.79-1.52,1.82-1.44s1.5,3.3,1.25,3.9-1.69.92-3.79.5S76.11,272.26,76.11,272.26Z",
    transform: "translate(-56.63 -105.42)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.43,270.6a29.38,29.38,0,0,1,3.18-.87c1.49-.33,3.28-.43,3.45-.17s-1.45.53-2.92.95-1,.52-1,.52-.09,0,1.45-.19,3.36-.15,3.53.18c.08.17,0,.27-.57.43.36,0,.41.07.42.22.07.74-2.34,1.33-3.3,1.57.74-.18,1.3-.23,1,.27s-3.75,1.26-5,1.62S78.43,270.6,78.43,270.6Z",
    transform: "translate(-56.63 -105.42)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.36,252.2c-1-.33-4,.73-4.5,3.78s-.71,6.45-1.18,8.1S56,273,57,273.62a11.5,11.5,0,0,0,5.59,1.15c2.77,0,13.48.48,13.48.48l.67-3.8s-4.07-.21-6.17-.53c-1.88-.29-4.48-1.09-7.55-1.42a51.16,51.16,0,0,1,1.12-5.79C64.63,262.43,67.92,253.67,63.36,252.2Z",
    transform: "translate(-56.63 -105.42)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "26.33 166.32 26.83 167.54 25.75 166.77 26.33 166.32"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "20.42 172.7 31.22 170.56 39.22 153.43 27.7 154.64 20.42 172.7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.19,273.08a8.92,8.92,0,0,0,1.12-1.32c.53-.77,2.25-3.71,2.09-3.89a5.78,5.78,0,0,0-3.18.17c-.46.42.46.58.46.58s-1.4.15-1.3.54.94.29.94.29-1.12.21-.95.56.71.34.71.34-1,.13-.88.51,1.71.73,1.5,1.05A6.66,6.66,0,0,0,89.19,273.08Z",
    transform: "translate(-56.63 -105.42)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M76.43,230.91s6.73,2.12,3.08,13.73-12.84-1.35-11.88-8.42S76.43,230.91,76.43,230.91Z",
    transform: "translate(-56.63 -105.42)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.2,237.69a15.21,15.21,0,0,1-8.94,3.69s-2.15,2.52-2.31,3.51c0,0-5-8.51,1.14-13.61S82.45,235.59,80.2,237.69Z",
    transform: "translate(-56.63 -105.42)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M71.33,241.61c0-.85-.57-2.77-1.82-2.23s.08,4.45.91,4.21C70.42,243.59,71.43,243.61,71.33,241.61Z",
    transform: "translate(-56.63 -105.42)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M75.24,249.28c0,.44-.09.94-.13,1.45h0c-3.89-1.92-4.48-4.69-4.5-4.77C73.38,249.54,75.24,249.28,75.24,249.28Z",
    transform: "translate(-56.63 -105.42)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M187.35,268.41a15.78,15.78,0,0,0,4,11.88c4.85,5.16,15.8,3.32,15.8,3.32s-1.81-6.1-5.78-8.61S189.59,271.62,187.35,268.41Z",
    transform: "translate(-56.63 -105.42)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M193,255.66a19.89,19.89,0,0,0-.56,15.77c3.44,8.24,17.16,10.91,17.16,10.91s.56-8-3-12.71S194.22,260.44,193,255.66Z",
    transform: "translate(-56.63 -105.42)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M372.61,158.78s6.8,10.32,1.06,15.81-6.41-.64-6.41-.64-3.08.2,3-6.79C373.17,163.87,372.61,158.78,372.61,158.78Z",
    transform: "translate(-56.63 -105.42)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M390.83,153.51s4.85,9.38-6.57,18.16-11.37,14.84-11.37,14.84S364.85,164.78,390.83,153.51Z",
    transform: "translate(-56.63 -105.42)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M371.43,182.52c-4.35-.13,2-11.15,9.08-13.39s12.72-1.31,17-4C397.53,165.09,392.8,183.11,371.43,182.52Z",
    transform: "translate(-56.63 -105.42)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.37,
    y: 41.97,
    width: 0.91,
    height: 109.28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.41,
    y: 120.59,
    width: 75.44,
    height: 0.91
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M386.2,312.36H238.09c-6.87,0-12.47-5.84-12.47-13V195.05c0-7.18,5.6-13,12.47-13H386.2c6.88,0,12.47,5.84,12.47,13V299.33C398.67,306.52,393.08,312.36,386.2,312.36ZM238.09,183.12c-6.27,0-11.37,5.35-11.37,11.93V299.33c0,6.58,5.1,11.93,11.37,11.93H386.2c6.27,0,11.38-5.35,11.38-11.93V195.05c0-6.58-5.11-11.93-11.38-11.93Z",
    transform: "translate(-56.63 -105.42)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M335.8,265.94h-1.11v-1.1c1.62,0,3.3,0,4.93,0l0,1.1C338.37,265.93,337.08,265.94,335.8,265.94Zm-6.06-.09c-1.65-.05-3.32-.12-4.94-.21l.06-1.09c1.61.09,3.27.16,4.91.21Zm14.85-.1,0-1.1c1.65-.07,3.31-.17,4.92-.28l.08,1.09C347.92,265.58,346.25,265.67,344.59,265.75Zm-24.73-.44c-3.1-.25-4.92-.49-4.94-.49l.14-1.09s1.82.24,4.89.49Zm34.62-.27-.11-1.09c1.64-.17,3.29-.36,4.89-.57l.14,1.09C357.79,264.68,356.13,264.87,354.48,265Zm9.82-1.29-.17-1.08c1.63-.27,3.26-.57,4.83-.89l.22,1.08C367.59,263.18,366,263.48,364.3,263.75Zm9.71-2-.25-1.07c1.61-.39,3.2-.81,4.74-1.25l.31,1C377.25,261,375.64,261.39,374,261.79Zm9.53-2.76-.35-1c1.57-.54,3.12-1.11,4.6-1.71l.41,1C386.7,257.91,385.13,258.49,383.54,259Zm9.22-3.7-.46-1c1.49-.71,3-1.45,4.37-2.23l.52,1C395.77,253.86,394.28,254.62,392.76,255.33Zm8.7-4.82-.59-.92c1.38-.89,2.72-1.84,4-2.82l.66.87C404.24,248.63,402.87,249.6,401.46,250.51Zm7.87-6.07-.74-.81c1.2-1.1,2.36-2.26,3.44-3.45l.81.73C411.74,242.13,410.56,243.31,409.33,244.44Zm6.67-7.37-.89-.66c1-1.3,1.88-2.66,2.71-4l.94.56C417.91,234.35,417,235.74,416,237.07Zm5.1-8.53-1-.47c.68-1.45,1.31-3,1.86-4.49l1,.37C422.44,225.51,421.8,227.06,421.1,228.54Zm3.37-9.34-1.06-.28c.4-1.54.75-3.14,1-4.76l1.08.19C425.23,216,424.88,217.63,424.47,219.2Zm1.7-9.77-1.09-.11c.16-1.58.25-3.23.3-4.88l1.09,0C426.43,206.15,426.33,207.82,426.17,209.43Zm-.82-9.89c-.05-1.59-.16-3.24-.31-4.89l1.1-.1c.15,1.67.25,3.34.31,5Zm-.87-9.76c-.22-1.58-.49-3.21-.8-4.84l1.08-.2c.31,1.64.58,3.29.8,4.89Zm-1.79-9.65-.42-1.79c-.24-1-.51-2-.79-3l1-.31c.29,1,.56,2,.8,3,.15.59.29,1.2.43,1.79Zm-2.77-9.35c-.59-1.53-1.24-3-1.95-4.46l1-.48c.72,1.46,1.39,3,2,4.54ZM83.08,164l-1-.46c.69-1.51,1.41-3,2.13-4.47l1,.49C84.47,161,83.77,162.52,83.08,164Zm332.54-2c-.85-1.38-1.78-2.72-2.75-4l.87-.67c1,1.31,1.95,2.69,2.82,4.09ZM87.44,155.23l-1-.53c.79-1.46,1.61-2.91,2.43-4.31l.94.56C89,152.33,88.23,153.77,87.44,155.23Zm322.29-.86c-1.1-1.17-2.27-2.31-3.49-3.38l.72-.83c1.25,1.1,2.45,2.26,3.57,3.46Zm-7.29-6.43c-1.29-.93-2.65-1.84-4.06-2.7l.57-.94c1.43.88,2.82,1.8,4.13,2.76Zm-310-1.17-.93-.6c.91-1.39,1.84-2.78,2.78-4.1l.89.63C94.24,144,93.32,145.38,92.43,146.77Zm301.69-3.91c-1.42-.73-2.91-1.43-4.43-2.09l.43-1c1.55.67,3.06,1.38,4.5,2.11Zm-9-3.89c-1.5-.55-3.06-1.07-4.65-1.57l.32-1c1.61.49,3.19,1,4.7,1.58Zm-287-.2-.87-.68c1-1.31,2.09-2.59,3.15-3.82l.83.71C100.16,136.2,99.11,137.47,98.1,138.77Zm277.67-2.72c-1.54-.4-3.15-.79-4.78-1.16l.24-1.07c1.65.37,3.27.77,4.82,1.17Zm-9.59-2.15c-1.57-.3-3.2-.58-4.85-.85l.18-1.08c1.66.27,3.3.55,4.87.85Zm-9.72-1.58c-1.57-.22-3.22-.43-4.88-.62l.12-1.09c1.68.19,3.33.4,4.91.62Zm-251.94-.95-.79-.76c1.15-1.2,2.34-2.37,3.54-3.47l.75.8C106.83,129,105.66,130.19,104.52,131.37Zm242.16-.21c-1.58-.16-3.23-.31-4.91-.46l.09-1.09c1.69.15,3.35.3,4.93.46Zm-9.83-.85c-1.56-.12-3.21-.24-4.92-.35l.08-1.09c1.7.11,3.36.22,4.93.34Zm-9.84-.66c-1.63-.09-3.27-.19-4.91-.27l.06-1.1,4.91.28Zm-9.84-.53-4.69-.24h-.24l.06-1.1.23,0,4.7.23Zm-9.87-.5-4.94-.26.06-1.1,4.94.26Zm-9.87-.54c-1.74-.1-3.36-.2-4.94-.31l.08-1.09,4.92.31Zm-9.87-.65c-1.69-.13-3.35-.26-4.92-.4l.09-1.09c1.57.13,3.23.27,4.92.39Zm-9.85-.86c-1.67-.17-3.33-.35-4.91-.53l.13-1.09c1.57.18,3.22.36,4.89.53Zm-9.82-1.15c-1.67-.23-3.32-.48-4.89-.73l.17-1.08c1.57.25,3.21.49,4.87.72Zm-156.18-.69-.69-.85c1.28-1,2.6-2.07,3.93-3l.64.89C114.28,122.69,113,123.69,111.71,124.73Zm146.41-.89c-1.65-.31-3.29-.64-4.85-1l.23-1.07c1.56.34,3.18.67,4.82,1Zm-9.67-2.13c-.72-.18-1.44-.37-2.14-.57l-2.63-.72.29-1.06,2.63.73,2.12.56Zm-9.52-2.6-4.76-1.29.28-1.06,4.76,1.3ZM119.65,119l-.58-.93c1.4-.88,2.84-1.72,4.29-2.5l.52,1C122.45,117.32,121,118.15,119.65,119Zm109.75-2.47-4.77-1.23.27-1.06,4.78,1.23Zm-101.14-2.19-.46-1c1.49-.69,3-1.34,4.57-1.94l.39,1C131.24,113,129.73,113.69,128.26,114.36Zm91.59-.24c-1.63-.4-3.25-.78-4.8-1.14l.25-1.07c1.56.36,3.17.75,4.81,1.15Zm-9.6-2.23c-1.63-.36-3.25-.7-4.82-1l.22-1.08c1.57.32,3.2.67,4.83,1Zm-72.87-1-.33-1c1.56-.49,3.16-1,4.77-1.36l.27,1.06C140.5,109.9,138.92,110.35,137.38,110.84Zm63.22-.92c-1.64-.3-3.27-.59-4.85-.85l.18-1.08c1.59.26,3.22.55,4.87.86Zm-53.73-1.5-.21-1.08c1.6-.31,3.25-.59,4.9-.83l.15,1.09C150.08,107.83,148.45,108.11,146.87,108.42Zm44-.1c-1.65-.24-3.29-.46-4.88-.64l.13-1.09c1.6.19,3.25.4,4.9.64Zm-9.77-1.16c-1.66-.15-3.31-.28-4.91-.37l.07-1.1c1.61.1,3.27.23,4.94.38ZM156.59,107l-.11-1.09c1.62-.15,3.28-.27,5-.36l0,1.1C159.83,106.75,158.19,106.87,156.59,107Zm14.71-.45c-1.23,0-2.47,0-3.68,0h-1.23v-1.09h1.24c1.22,0,2.47,0,3.71,0Z",
    transform: "translate(-56.63 -105.42)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M415.65,158.17a31.77,31.77,0,0,0-3.4-8.19l3.46-5.21-4.8-4.8-4.8-4.8-5.21,3.46a31.77,31.77,0,0,0-8.19-3.4l-1.23-6.12H377.9l-1.23,6.12a31.69,31.69,0,0,0-8.2,3.4l-5.2-3.46-4.81,4.8-4.8,4.8,3.46,5.21a32.12,32.12,0,0,0-3.4,8.19l-6.12,1.23V173l6.12,1.24a32.12,32.12,0,0,0,3.4,8.19l-3.46,5.21,4.8,4.8,4.81,4.8,5.2-3.46a32,32,0,0,0,8.2,3.4l1.23,6.12h13.58l1.23-6.12a32.12,32.12,0,0,0,8.19-3.4l5.21,3.46,4.8-4.8,4.8-4.8-3.46-5.21a31.77,31.77,0,0,0,3.4-8.19l6.12-1.24V159.4Zm-31,31.81a23.79,23.79,0,1,1,23.79-23.79A23.79,23.79,0,0,1,384.69,190Z",
    transform: "translate(-56.63 -105.42)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 148.05,
    y: 63.71,
    width: 180.01,
    height: 129.24,
    rx: 12.48
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.16,201.77a36.92,36.92,0,1,0-69.53,24.87c.28.78.58,1.55.91,2.3a36.37,36.37,0,0,0,5.72,9.19,36.93,36.93,0,0,0,62.9-36.36Zm-25.44,38.5a27.63,27.63,0,0,1-34.71-15c-.24-.56-.47-1.14-.68-1.72a27.68,27.68,0,1,1,35.39,16.74Z",
    transform: "translate(-56.63 -105.42)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M227,206l-8.82-2.75a37,37,0,0,1,34.14-25.91l.28,9.24A27.71,27.71,0,0,0,227,206Z",
    transform: "translate(-56.63 -105.42)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M228,225.25l-8.47,3.69c-.33-.75-.63-1.52-.91-2.3a36.67,36.67,0,0,1-.48-23.44L227,206a27.54,27.54,0,0,0,.36,17.58C227.54,224.11,227.77,224.69,228,225.25Z",
    transform: "translate(-56.63 -105.42)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M225.26,238.13a36.37,36.37,0,0,1-5.72-9.19l8.47-3.69a27.44,27.44,0,0,0,4.29,6.9Z",
    transform: "translate(-56.63 -105.42)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M227.56,291.23a18.71,18.71,0,1,0,16-33.83c-.38-.18-.76-.34-1.15-.5a18.71,18.71,0,0,0-14.85,34.33Zm-4.68-22.91a14,14,0,0,1,17.82-7.06c.29.12.58.24.86.38a14,14,0,1,1-18.68,6.68Z",
    transform: "translate(-56.63 -105.42)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M248,267.81l4.15-2.18a18.71,18.71,0,0,1,.34,16.69,18.9,18.9,0,0,1-3.29,4.83l-3.41-3.21A14.07,14.07,0,0,0,248,267.81Z",
    transform: "translate(-56.63 -105.42)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M240.7,261.26l1.71-4.36c.39.16.77.32,1.15.5a18.63,18.63,0,0,1,8.58,8.23L248,267.81a14,14,0,0,0-6.43-6.17C241.28,261.5,241,261.38,240.7,261.26Z",
    transform: "translate(-56.63 -105.42)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M237.07,255.66a18.82,18.82,0,0,1,5.34,1.24l-1.71,4.36a13.9,13.9,0,0,0-4-.93Z",
    transform: "translate(-56.63 -105.42)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M384.69,181.61V285.9a12.48,12.48,0,0,1-12.48,12.48H303.56V169.14h68.65A12.47,12.47,0,0,1,384.69,181.61Z",
    transform: "translate(-56.63 -105.42)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 257.36,
    y: 77.12,
    width: 60.28,
    height: 6.57,
    rx: 1.63
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 257.36,
    y: 91.21,
    width: 60.28,
    height: 6.57,
    rx: 1.63
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 257.36,
    y: 107.36,
    width: 60.28,
    height: 74.26,
    rx: 5.47
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 253.44,
    y: 104.21,
    width: 21.4,
    height: 55.04,
    rx: 6.73
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.05,
    y: 57.74,
    width: 137.56,
    height: 0.91
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M184.46,155.61a7.38,7.38,0,1,1,7.37-7.37A7.39,7.39,0,0,1,184.46,155.61Zm0-13.65a6.28,6.28,0,1,0,6.27,6.28A6.28,6.28,0,0,0,184.46,142Z",
    transform: "translate(-56.63 -105.42)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M164.69,239.63s6.89,1.23,6.95,7.06-5.27,14.28-8.74,13.66-7.41-3.71-7.28-7.25,1.12-8.21,2.72-10.77S162.77,239.5,164.69,239.63Z",
    transform: "translate(-56.63 -105.42)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M155.86,250.39s0,1.19,2.38,2.14,6.72-.38,7.82-.16,1.41-.31,1.41-.31l.08,1.16.92.63s.65-3.1,2.6-3.36,3.57-9.17-4.82-10.85c0,0-6.22-1.69-7.82,1.46S155.56,248.17,155.86,250.39Z",
    transform: "translate(-56.63 -105.42)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 88.53,
    y: 176.31,
    width: 70.07,
    height: 70.07,
    rx: 8.05
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 83.1,
    y: 63.71,
    width: 70.08,
    height: 53.22,
    rx: 7.02
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 126.04,
    y: 186.61,
    width: 27.22,
    height: 7.54,
    rx: 1.65
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 126.04,
    y: 197.98,
    width: 27.22,
    height: 39.95,
    rx: 3.79
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M160.91,313.28a12.5,12.5,0,0,0,16.53-11.7c0-.28,0-.56,0-.84a12.66,12.66,0,0,0-.73-3.6,12.53,12.53,0,1,0-15.79,16.14Zm-5.37-12a9.39,9.39,0,0,1,18.21-3.09h0a9.26,9.26,0,0,1,.55,2.69c0,.21,0,.42,0,.63a9.38,9.38,0,0,1-9.51,9.27,9.52,9.52,0,0,1-2.89-.5A9.37,9.37,0,0,1,155.54,301.3Z",
    transform: "translate(-56.63 -105.42)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M172.35,307.17l2.48,1.92a12.53,12.53,0,0,1-13.92,4.19l1-3a9.52,9.52,0,0,0,2.89.5A9.38,9.38,0,0,0,172.35,307.17Z",
    transform: "translate(-56.63 -105.42)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M174.3,300.91l3.13-.17c0,.28,0,.56,0,.84a12.51,12.51,0,0,1-2.62,7.51l-2.48-1.92a9.43,9.43,0,0,0,2-5.63C174.31,301.33,174.31,301.12,174.3,300.91Z",
    transform: "translate(-56.63 -105.42)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M174.3,300.91a9.26,9.26,0,0,0-.55-2.69h0l2.95-1.07a12.66,12.66,0,0,1,.73,3.6Z",
    transform: "translate(-56.63 -105.42)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M157.39,291.42a12.53,12.53,0,0,1,19.31,5.72l-2.95,1.08h0A9.39,9.39,0,0,0,165,292a9.28,9.28,0,0,0-5.81,1.93Z",
    transform: "translate(-56.63 -105.42)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "16.03 87.43 31.12 63.84 23.46 67.32 16.03 87.43"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "16.03 87.43 16.95 73.21 22.43 70.09 16.03 87.43"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "27.65 69.27 29.54 71.75 16.03 87.43 27.65 69.27"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M177.53,285.33a2.12,2.12,0,0,0,1.07-.49c.67-.69.74-2.15,2.1-2.25s2.63,4,2.41,4.89-2,1.53-4.89,1.4S177.53,285.33,177.53,285.33Z",
    transform: "translate(-56.63 -105.42)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.24,282.69s1.85-.95,4-1.77c1.9-.72,4.25-1.23,4.51-.91.57.73-1.65,1.24-3.49,2.08a14.1,14.1,0,0,0-1.41.64s-.12,0,1.87-.53c2.15-.53,4.39-.86,4.67-.46.14.19.39.88-.51.85.47-.09.4-.17.44,0,.24,1-2.81,2.22-4,2.72.94-.38,1.66-.56,1.41.15s-4.68,2.4-6.21,3.11S180.24,282.69,180.24,282.69Z",
    transform: "translate(-56.63 -105.42)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M147.63,256.81a50.81,50.81,0,0,0-7.34,0c-3,.31-7.24,2.79-9.78,3.51s-8.67,4.84-8.5,5.4a45.61,45.61,0,0,0,6.93,12.71C132.7,283.09,147.63,256.81,147.63,256.81Z",
    transform: "translate(-56.63 -105.42)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M138.34,259.51s-4.64,3.43-6.25,6.58a25.39,25.39,0,0,0-2.17,6.9Z",
    transform: "translate(-56.63 -105.42)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M141.86,361.8a11,11,0,0,0,2.09,1.78c.76.37,9.92,1.95,10.54,2.69s.62,3.69-1.74,3.69-10.23,0-11.56,0-6.92,1.16-7.5,0-.52-6.57.51-7.87S141.86,361.8,141.86,361.8Z",
    transform: "translate(-56.63 -105.42)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M141.58,360.15l.28,1.65s-2.45,1.12-7.66.29v-1.7Z",
    transform: "translate(-56.63 -105.42)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M86,357.24A9.1,9.1,0,0,0,84.46,360c-.32,1-1.86,5.59-1.2,6.71s5.88,1.28,8.49.87,8.28.45,8.86-.67.91-2.75-.79-3.38-5.59-2.29-6.29-4S86,357.24,86,357.24Z",
    transform: "translate(-56.63 -105.42)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M94.25,357.62l-.72,1.86s-7.48-.56-7.54-2.24l2.36-3.43Z",
    transform: "translate(-56.63 -105.42)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.63,253.63s-4.17,3.54-5.35,3.25,4.08,7.49,4.08,7.49,5-4.94,6.16-5.09S155.63,253.63,155.63,253.63Z",
    transform: "translate(-56.63 -105.42)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M155.91,267.61c-1.41.85-1.65,1.13-1.49,5.19s1.85,7.33,2,8.45,2.37,12.21,3,12.83,8-.83,9.54-1.29c2.25-.7,11.77-3.92,11.77-3.92l-2.1-4.37s-12,2.68-12.39,1.74-1.33-8.82-1.66-10.53.24-4.4-1.8-8.46C160.93,263.61,155.91,267.61,155.91,267.61Z",
    transform: "translate(-56.63 -105.42)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M141.83,298.14s2.55,2.71,3.26,3.59a141.36,141.36,0,0,1,12.34,19c.83,1.93-4.1,15.6-6.13,20.37-1.06,2.51-8.09,19.76-7.87,20.14s-7.43.65-10.85-1.12c0,0,4.92-14.59,5.95-17.44,1.57-4.32,7-16.28,7.17-17.44s-8.78-10.73-11.76-12.55-10.27-8.28-11.1-9.11-5.53-3-5.08-7.23a14.65,14.65,0,0,1,3.56-7.51Z",
    transform: "translate(-56.63 -105.42)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M128.45,308.53s-.47,1.22-1.12,2.94c-1.4,3.69-3.67,9.64-4,10.58-.55,1.39-3.32,7.35-4.64,8.51S95.5,357.89,95.45,358.11s-8.17-4-8.67-5.57c0,0,11.82-15.41,13.64-17.67s5.63-5.64,6.9-11,10.38-26,10.41-26.73c0,0,1.46-6.35,3.59-8.28s9.86.33,11.07,4.36S128.45,308.53,128.45,308.53Z",
    transform: "translate(-56.63 -105.42)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M149.9,256.84l1.76-.69a13.19,13.19,0,0,1,7,4.58l-.22,1.07S151.67,260.33,149.9,256.84Z",
    transform: "translate(-56.63 -105.42)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M156.69,282.77a7.35,7.35,0,0,1-.83,1l-.46.38h0l-.17-6.68s.84,2.57,1,2.95S156.69,282.77,156.69,282.77Z",
    transform: "translate(-56.63 -105.42)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M128.45,308.53s-.47,1.22-1.12,2.94c-1.48-1.71-4.87-8.17-4.87-8.17.22.16.93.83,1.09,1Z",
    transform: "translate(-56.63 -105.42)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M166.38,251.84c.16-.5-.22-2.44-1.45-1.33s-1.23,3.56-.54,3.77S166,253.13,166.38,251.84Z",
    transform: "translate(-56.63 -105.42)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M161.77,241s-6-4.25-6,10.24Z",
    transform: "translate(-56.63 -105.42)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M156.69,282.77a7.35,7.35,0,0,1-.83,1l-.46.38h0a69.89,69.89,0,0,1-7.22,4.92c-1.93,1.05-5.59,9.89-5.59,9.89s-17.3-1.17-21.27-10.11a78.07,78.07,0,0,1,5.38-10c2.57-3.73,8.2-17.15,11.18-19.06s5.55-3.14,11.43-3a12.33,12.33,0,0,1,9.14,4.83s4.48,4.81,4.92,7.35C163.75,271.17,158.89,279.7,156.69,282.77Z",
    transform: "translate(-56.63 -105.42)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M209.81,176.16l-.12,3.89H139.61l.12-3.89a7,7,0,0,1,7-7h56A7,7,0,0,1,209.81,176.16Z",
    transform: "translate(-56.63 -105.42)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.71,217.87h-14.1a3.3,3.3,0,0,1-3.3-3.3V186.46a3.3,3.3,0,0,1,3.3-3.3h14.1a3.31,3.31,0,0,1,3.31,3.3v28.11A3.31,3.31,0,0,1,161.71,217.87Zm-14.1-33.61a2.21,2.21,0,0,0-2.2,2.2v28.11a2.21,2.21,0,0,0,2.2,2.21h14.1a2.21,2.21,0,0,0,2.21-2.21V186.46a2.21,2.21,0,0,0-2.21-2.2Z",
    transform: "translate(-56.63 -105.42)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.13,
    y: 78.28,
    width: 35.79,
    height: 2.92,
    rx: 1.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.13,
    y: 84.22,
    width: 35.79,
    height: 2.92,
    rx: 1.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 204.5,
    y: 154.37,
    width: 25.58,
    height: 6.82,
    rx: 1.7
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 204.5,
    y: 165.49,
    width: 25.58,
    height: 6.82,
    rx: 1.7
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 204.5,
    y: 176.6,
    width: 25.58,
    height: 6.82,
    rx: 1.7
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M151,175.06a3,3,0,1,1-3-3.05A3,3,0,0,1,151,175.06Z",
    transform: "translate(-56.63 -105.42)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M380,280.33s12.38,4,15.24,3.29c1.51-.37,3.87-2.52,6.07-4.83l1.07-1.15c2.42-2.66,4.4-5.2,4.4-5.2s6-7,1.18-10.16a6.44,6.44,0,0,0-3.73,1.92,24.71,24.71,0,0,0-3.53,5.38c-.42.91-6.3,9.41-6.61,9.6s-2.88-.49-4.94-.66a44.9,44.9,0,0,1-8.4-2Z",
    transform: "translate(-56.63 -105.42)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M397,356.6s-1.57,2.81-2.51,3.39c-1.17.71-3.43,3-4.22,3.09s-3.63.61-3.08,2.22c.45,1.31,7.22,1.12,8,.46s3.05-3,4-3,.58,3.42.58,3.42h1s.35-3.27.39-3.83c.13-1.67-1.06-2.89-1.11-3.84s-.11-1.65-.11-1.65Z",
    transform: "translate(-56.63 -105.42)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M390.53,363a5.39,5.39,0,0,0,4-.22c1.72-1,5-2.49,6.19-2.5,0,0-.64-1.94-.65-2.16s-.09-1.24-.09-1.24l-2.88-.47a24.81,24.81,0,0,1-2.7,3.4A46.43,46.43,0,0,0,390.53,363Z",
    transform: "translate(-56.63 -105.42)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M424.27,359.25a11.78,11.78,0,0,1-.59,2.48c-.3.53-1.14,3.24-1.51,3.75s-1.22,4.3,0,4.76,4.07,1.22,5-.3a6.27,6.27,0,0,0,.93-4.21c-.15-1.16-1.31-6.51-1.29-7S424.27,359.25,424.27,359.25Z",
    transform: "translate(-56.63 -105.42)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M422.65,364.43s-.13,2.95,2.1,2.95,3.21-2.69,3.21-2.69.76,1.32,0,4.13-3.92,2.23-4.63,2.13S419.26,370,422.65,364.43Z",
    transform: "translate(-56.63 -105.42)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M420.59,292a36.15,36.15,0,0,1,3.9,6.1c1,2.43,2.71,7.76,2.48,11.88s-1.58,11.86-1.18,13.61.79,5.37,1.21,6.61,2.12,4.86,2.29,8.59-1.21,20.08-1.09,21.61-4.94.59-4.94.59-.13-14.74-.69-17.28-1.25-11.19-1.75-11.81-1.94-7.18-2-8.25-6.13-18.95-6.47-22-7.91-9.65-7.91-9.65A26.4,26.4,0,0,1,420.59,292Z",
    transform: "translate(-56.63 -105.42)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M401.82,357.4c1.07-.16,3.95-16.69,3.61-19.63s-.68-9.2.28-11.74c.63-1.67,4.57-10.17,7.22-16.14l1-2.35a26,26,0,0,0,1.41-3.6c.06-1.13,3.74-20.6-10.81-11.94a17.61,17.61,0,0,1-.32,2.11c-.17.56-4.06,15-4.46,20.5A110.77,110.77,0,0,1,398.2,326a24.4,24.4,0,0,0,.51,6.15c.34,1-2.21,24-2.38,24.54S400.75,357.57,401.82,357.4Z",
    transform: "translate(-56.63 -105.42)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M410.27,261.25a29.06,29.06,0,0,1-3.71,1.49c-1,.19-4.67,5-5.32,6.77s0,4.4,1.34,7.5.07,4.13.68,7.22a70.53,70.53,0,0,1,1,11.38c-.11,1.72,15.47,2.05,19-1.08,0,0-3.57-5.36-4-6.12s-.08-4.94.34-6,3.41-9.91,3.41-9.91,2.11-7.26,0-8.86c-1.8-1.4-6.7-1.9-7.58-2.2A15,15,0,0,0,410.27,261.25Z",
    transform: "translate(-56.63 -105.42)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M409.39,267.39l-1.68-2,1.46-5.16A33.88,33.88,0,0,1,409.39,267.39Z",
    transform: "translate(-56.63 -105.42)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M409,258.07s.54,5.06.43,6.7c0,0,2.86,2.87,6.11-3.34a8.59,8.59,0,0,1-.33-6.06C416.2,251.88,409,258.07,409,258.07Z",
    transform: "translate(-56.63 -105.42)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "352.76 159.35 352.76 161.97 356.05 159.51 352.76 159.35"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "352.76 161.97 354.13 160.28 358.73 155.69 360.22 157.12 352.76 161.97"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M414.68,298.09c1.29,6.21,10.67-.7,10.67-.7s-6.08-10.22-3.66-18.38l.06-.2c.15-.51.31-1,.46-1.47,0-.09.06-.17.08-.25.53-1.61,1-2.94,1.31-4h0c1.08-3.36,1.4-4.47,1.4-4.47s-.46-5.23-3.05-5.8-5.33-1.12-5.33-1.12-4.49,5.74-4.67,8.32S413.38,291.88,414.68,298.09Z",
    transform: "translate(-56.63 -105.42)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M400.86,270.7a16.58,16.58,0,0,0,2.15,8.23s-.05,6.26-.13,8.44-.59,10.42-.59,10.42l2.68,1.57a.76.76,0,0,0,1.14-.74c-.76-6.27-3.23-30.07,2.12-36.46l-2.39.82S400.86,268.21,400.86,270.7Z",
    transform: "translate(-56.63 -105.42)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "351.09 160.01 348.98 160.59 352.54 154.85 351.09 160.01"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "354.13 160.28 356.05 162.8 359.99 156.24 358.73 155.69 354.13 160.28"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M411,241.77a6.86,6.86,0,0,0-7.49,5.93,16.23,16.23,0,0,0,.39,2.6c.3,1.15-.88,4.45-.62,4.62a7.2,7.2,0,0,0,1.34.44s1,3.71,2.29,3.74a10.65,10.65,0,0,0,8.69-5.18C418.05,249.49,419.08,242.55,411,241.77Z",
    transform: "translate(-56.63 -105.42)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M403.46,247.7a18.2,18.2,0,0,0,6.41,3c3.23.6,5,6.23,5,6.23s5.42-8.15,1.66-13.37S403.05,241.43,403.46,247.7Z",
    transform: "translate(-56.63 -105.42)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M411.23,250.61A1,1,0,0,1,413,250c1,.91-.54,3.84-1.37,3.51S411.18,251.26,411.23,250.61Z",
    transform: "translate(-56.63 -105.42)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M409,258.8c.07.4.15.86.21,1.34a14,14,0,0,0,4.13-3.51A15.85,15.85,0,0,1,409,258.8Z",
    transform: "translate(-56.63 -105.42)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M351.28,292.94l40.2.2a4,4,0,0,0,4-4l.13-26.82a4,4,0,0,0-4-4l-40.2-.2a4,4,0,0,0-4,4l-.13,26.82A4,4,0,0,0,351.28,292.94Z",
    transform: "translate(-56.63 -105.42)"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M369.18,290.25l20.49.1a2.61,2.61,0,0,0,2.62-2.6l.12-22.79a2.62,2.62,0,0,0-2.6-2.63l-20.5-.1a2.61,2.61,0,0,0-2.62,2.6l-.11,22.79A2.61,2.61,0,0,0,369.18,290.25Z",
    transform: "translate(-56.63 -105.42)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M352.48,286h11.84a.73.73,0,0,1,.73.73v2.81a.73.73,0,0,1-.73.73H352.48a.74.74,0,0,1-.74-.74v-2.81A.74.74,0,0,1,352.48,286Z",
    transform: "translate(658.75 472.6) rotate(-179.72)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M352.14,284.67l12.52.06a.4.4,0,0,0,.4-.4v-.46a.4.4,0,0,0-.4-.4l-12.51-.07a.4.4,0,0,0-.4.4v.47A.39.39,0,0,0,352.14,284.67Z",
    transform: "translate(-56.63 -105.42)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M397.1,281.88a1.49,1.49,0,0,1-.84-.06c-.62-.29-1-1.26-2-1s-.75,3.36-.39,3.88,1.75.52,3.62-.29S397.1,281.88,397.1,281.88Z",
    transform: "translate(-56.63 -105.42)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M394.62,280.79a29,29,0,0,0-3.13-.18c-1.45,0-3.13.24-3.24.52s1.46.21,2.9.31,1.06.28,1.06.28a5.54,5.54,0,0,0-1.39.11c-1.57.19-3.15.53-3.24.87-.05.16,0,.25.61.28-.34,0-.36.15-.35.28.08.71,2.45.79,3.38.82-.72,0-1.25,0-.9.45s3.73.43,4.94.53S394.62,280.79,394.62,280.79Z",
    transform: "translate(-56.63 -105.42)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M414.25,249.48c-1,2.26-.39,4.7,1.34,5.46s3.94-.45,4.93-2.7.39-4.7-1.34-5.46S415.24,247.23,414.25,249.48Z",
    transform: "translate(-56.63 -105.42)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M422.48,263a6.38,6.38,0,0,0-3.84,2.45,28.83,28.83,0,0,0-2.81,5.77c-.25,1-5.06,9.95-5.33,10.19s-2.92,0-5,.25a45.74,45.74,0,0,1-8.62-.46l0,3.88s12.9,1.7,15.58.5c3.28-1.48,11.23-12.57,11.23-12.57S427.78,265.2,422.48,263Z",
    transform: "translate(-56.63 -105.42)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M417.27,281.11l5-4c.53-1.61,1-2.94,1.31-4C423.6,273.06,418.51,279.74,417.27,281.11Z",
    transform: "translate(-56.63 -105.42)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M401.32,278.79l1.07-1.15a27.87,27.87,0,0,1-1.45-5.15A22.36,22.36,0,0,0,401.32,278.79Z",
    transform: "translate(-56.63 -105.42)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M363.17,265.53a5.86,5.86,0,0,0-5.71-3.9,6.09,6.09,0,0,0-1.81.34,5.85,5.85,0,0,0-3.63,3.78,5.92,5.92,0,0,0,.07,3.74l.15.36a5.5,5.5,0,0,0,.91,1.47,5.88,5.88,0,0,0,10-5.79Zm-4.05,6.13a4.43,4.43,0,0,1-4.85-1.3,4.35,4.35,0,0,1-.68-1.09c0-.09-.08-.19-.11-.28a4.39,4.39,0,0,1,2.67-5.63,4.25,4.25,0,0,1,1.35-.26,4.41,4.41,0,0,1,1.62,8.56Z",
    transform: "translate(-56.63 -105.42)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M353.42,266.19l-1.4-.44a5.85,5.85,0,0,1,3.63-3.78,6.09,6.09,0,0,1,1.81-.34l0,1.47a4.25,4.25,0,0,0-1.35.26A4.39,4.39,0,0,0,353.42,266.19Z",
    transform: "translate(-56.63 -105.42)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M353.59,269.27l-1.35.58-.15-.36a5.92,5.92,0,0,1-.07-3.74l1.4.44a4.41,4.41,0,0,0,.06,2.8C353.51,269.08,353.55,269.18,353.59,269.27Z",
    transform: "translate(-56.63 -105.42)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M353.15,271.32a5.5,5.5,0,0,1-.91-1.47l1.35-.58a4.35,4.35,0,0,0,.68,1.09Z",
    transform: "translate(-56.63 -105.42)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M356.55,275.85a2.42,2.42,0,0,0-2.35-1.6,2.11,2.11,0,0,0-.74.14,2.37,2.37,0,0,0-1.49,1.55,2.33,2.33,0,0,0,0,1.54l.06.15a2.31,2.31,0,0,0,.37.6,2.42,2.42,0,0,0,4.12-2.38Zm-1.67,2.52a1.83,1.83,0,0,1-2-.53,2.11,2.11,0,0,1-.28-.45s0-.08,0-.12a1.81,1.81,0,0,1,0-1.15,1.84,1.84,0,0,1,1.68-1.27,1.81,1.81,0,0,1,.66,3.52Z",
    transform: "translate(-56.63 -105.42)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M352.54,276.12l-.57-.18a2.37,2.37,0,0,1,1.49-1.55,2.11,2.11,0,0,1,.74-.14l0,.6a1.84,1.84,0,0,0-1.68,1.27Z",
    transform: "translate(-56.63 -105.42)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M352.61,277.39l-.55.24-.06-.15a2.33,2.33,0,0,1,0-1.54l.57.18a1.81,1.81,0,0,0,0,1.15S352.6,277.35,352.61,277.39Z",
    transform: "translate(-56.63 -105.42)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M352.43,278.23a2.31,2.31,0,0,1-.37-.6l.55-.24a2.11,2.11,0,0,0,.28.45Z",
    transform: "translate(-56.63 -105.42)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.96,
    y: 96.2,
    width: 4.27,
    height: 15.7
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.04,
    y: 94.62,
    width: 4.27,
    height: 17.28
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 125.19,
    y: 97.91,
    width: 4.27,
    height: 14
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.35,
    y: 91.42,
    width: 4.27,
    height: 20.48
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 137.81,
    y: 93.46,
    width: 4.27,
    height: 18.44
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagement);
export default __webpack_public_path__ + "static/media/project-management.1fecbb2c3d992c7372b58d3dc43fad85.svg";
export { ForwardRef as ReactComponent };